<template>
  <div style="background-color: white">
    <property-form
      ref="propertyForm"
      :no_editing="true"
      :value="
        value ||
        ['fio', 'responsible_user_id'].reduce((a, v) => {
          a[v] = '';
          return a;
        }, {})
      "
      :fields="fields"
      @input="doSave"
    />
    <consent-checkbox v-model="consent_given" class="mt-4" />
    <v-card-actions>
      <v-btn
        class="white--text"
        style="
          background-color: #d86568;
          width: 150px;
          height: 50px;
          border-radius: 50px;
        "
        :disabled="!isFormValid"
        @click="doSave"
      >
        Сохранить
      </v-btn>
    </v-card-actions>
    <error-message-wrapper ref="error_wrapper" />
  </div>
</template>

<script>
import PropertyForm from "@/components/PropertyForm";
import { mapActions, mapGetters } from "vuex";
import { VSelect } from "vuetify/lib/components";
import ErrorMessageWrapper from "@/components/ErrorMessageWrapper.vue";
import ConsentCheckbox from "@/components/ConsentCheckbox.vue";

export default {
  name: "NewPatientForm",
  components: { ErrorMessageWrapper, PropertyForm, ConsentCheckbox },
  data() {
    return {
      consent_given: false,
      userIdValidationMessage: "",
      fioRules: [(v) => !!v || "Обязательное поле"],
      emailRules: [
        (v) => !v || /.+@.+\..+/.test(v) || "Пример: abc@de.fg",
        (v) => !v || !v.includes(" ") || "Пробелы запрещены",
        (v) => {
          // Если есть пароль, то email обязателен
          if (this.value?.password && !v) {
            return "Email обязателен при указании пароля";
          }
          return true;
        },
      ],
      passwordRules: [
        (v) =>
          !v ||
          /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[\W_]).{8,}$/.test(v) ||
          "Минимум 8 символов, цифры, буквы, знаки",
        (v) => !v || !v.includes(" ") || "Пробелы запрещены",
      ],
      emailPasswordRules: [
        (v) => {
          // Если есть email, то пароль обязателен
          if (this.value?.email && !v) {
            return "Пароль обязателен при указании email";
          }
          return true;
        },
      ],
      userIdRules: [(v) => !!v || "Обязательное поле"],
    };
  },
  computed: {
    ...mapGetters("modals", ["modalFormComponent"]),
    ...mapGetters("users", ["users"]),

    isFormValid() {
      if (!this.consent_given) return false;
      // We can't check validity of the child form directly in a computed property
      // because it would be too complex. We will check it on save.
      return true;
    },
    value() {
      return this.modalFormComponent?.value;
    },
    fields() {
      return {
        fio: {
          order: 1,
          label: "ФИО",
          visible: true,
          rules: this.fioRules,
        },
        email: {
          order: 2,
          label: "E-Mail",
          visible: true,
          rules: [...this.emailRules, ...this.emailPasswordRules],
        },
        responsible_user_id: {
          order: 3,
          label: "Ответственный",
          component: VSelect,
          items: this.users
            .filter((user) => user.role !== "patient")
            .map((c) => ({ value: c.id, text: c.full_name })),
          visible: true,
          rules: this.userIdRules,
        },
        password: {
          order: 4,
          label: "Пароль",
          visible: true,
          rules: [...this.passwordRules, ...this.emailPasswordRules],
        },
      };
    },
  },
  beforeMount() {
    this.request_users();
  },
  methods: {
    ...mapActions("users", ["request_users"]),
    async doSave() {
      const isPropertyFormValid = this.$refs.propertyForm.validate();
      if (!this.consent_given || !isPropertyFormValid) {
        if (!this.consent_given) {
          await this.$refs.error_wrapper.showErrorMessage(
            "Ошибка валидации",
            "Необходимо получить согласие на обработку персональных данных."
          );
        }
        return;
      }

      const value = this.$refs.propertyForm.getValue();
      await this.request_users("all=1");

      // Проверка связи email и пароль
      if (
        (value.email && !value.password) ||
        (!value.email && value.password)
      ) {
        await this.$refs.error_wrapper.showErrorMessage(
          "Ошибка валидации",
          "Email и пароль должны быть указаны вместе. Либо заполните оба поля, либо оставьте их пустыми."
        );
        return;
      }

      // Existing user, password is undefined, skip password validation
      const conflictUser = this.users.find((user) => {
        return user.email === value.email;
      });

      if (conflictUser) {
        var message = "Попробуйте выбрать другой E-Mail";
        await this.$refs.error_wrapper.showErrorMessage(
          "Данный E-Mail уже занят",
          message
        );
        return;
      }
      this.$emit("confirm", { ...value });
    },
  },
};
</script>

<style scoped lang="scss">
.error-message {
  background-color: white;
  color: red;
  font-weight: bold;
  margin-left: 20px;
  margin-bottom: 0px;
  padding-bottom: 5px;
}
</style>
